import { z } from 'zod';

const legacyCanvasShapeEntrySchema = z.object({
  kind: z.literal("legacyCanvasShape"),
  backgroundColor: z.string().optional()
});

export { legacyCanvasShapeEntrySchema };
//# sourceMappingURL=LegacyCanvasShapeEntry.js.map
